import { Finyearmst } from "./tallyentry-api-model";

export class DashboardModel {

    public finyearmst: Finyearmst;
    public receiptEntries: ReceiptEntries;
    public txnCountJsym: number;
    public txnAmountJsym: number;
    public txnCountTaam: number;
    public txnAmountTaam: number;
  
    constructor(init?: Partial<DashboardModel>) {
      Object.assign(this, init);
    }
}

export class ReceiptEntries {

    public donation: number;
    public yogprakash: number;
    public booksale: number;
    public pariksha: number;
  
    constructor(init?: Partial<ReceiptEntries>) {
      Object.assign(this, init);
    }
}

export class Analytics {

  public finyearmstId: number;
  public txncategoryId: number;
  public fromDate: Date;
  public toDate: Date;
  public bookNo: number;

  constructor(init?: Partial<Analytics>) { 
    Object.assign(this, init);
  }
}

export class DashboardResponseModel {

  public txnCountJsym: number;
  public txnAmountJsym: number;
  public txnCountTaam: number;
  public txnAmountTaam: number;
  public donationCount: number;
  public donationAmount: number;
  public yogprakashCount: number;
  public yogprakashAmount: number;
  public booksCount: number;
  public booksAmount: number;
  public parikshaCount: number;
  public parikshaAmount: number;
  public miscellaneousCount: number;
  public miscellaneousAmount: number;

  constructor(init?: Partial<DashboardResponseModel>) {
    Object.assign(this, init);
  }
}